import { Component } from '@angular/core';

import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatCardModule } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Router, RouterModule, Routes } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'app-app-hub',
    imports: [
    MatButtonModule,
    MatCheckboxModule,
    MatInputModule,
    MatRadioModule,
    MatFormFieldModule,
    MatCardModule,
    FormsModule,
    ReactiveFormsModule,
    MatDatepickerModule,
    MatToolbarModule,
    RouterModule,
    MatIconModule
],
    templateUrl: './app-hub.component.html',
    styleUrl: './app-hub.component.css'
})
export class AppHubComponent {

  apps = [
    { name: 'JSA Reporting App', icon: 'quick_reference_all', description: 'Qucikly view & monitor JSA submission data based on search queries.', link: '/reports', flipped: false },
    { name: 'JSA PDF', icon: 'file_save', description: 'Find a specific JSA submission and download it as a PDF. ', link: '/pdf-download', flipped: false },
    { name: 'Excel Safety Reports', icon: 'rubric', description: 'Translate safety form submissions from database to spreadsheet.', link: '/export-excel', flipped: false },
    { name: 'LP Safety Analytics', icon: 'monitoring', description: 'Analyze and visualize realtime safety form data across JSA, Good Catch, and Near Miss submissions.', link: '/safety-analytics', flipped: false },
    
  ];
  depApps = [
    { name: 'Near Miss PDF', icon: 'file_save', description: 'Find a specific NearMiss submission and download it as a PDF. ', link: '/pdf-download-nm', flipped: false },
    { name: 'Good Catch PDF', icon: 'file_save', description: 'Find a specific GoodCatch submission and download it as a PDF. ', link: '/pdf-download-gc', flipped: false },
    { name: 'Accident Report PDF', icon: 'file_save', description: 'Find a specific AccidentReport submission and download it as a PDF. ', link: '/pdf-download-accident', flipped: false },
  ];
  constructor(private router: Router) {}

  flipCard(app: any) {
    app.flipped = !app.flipped;
  }

  navigateTo(link: string) {
    this.router.navigate([link]);
  }
}
